import apiClient from './config';

const orderApi = {
  // Get all orders
  getOrders: async (params = {}) => {
    try {
      const response = await apiClient.get('/orders', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get orders by mobile number
  getOrdersByMobile: async (mobileNumber) => {
    try {
      const response = await apiClient.get(`/order-mobile`, {
        headers: {
          'Authorization': `${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get order by ID
  getOrderById: async (orderId) => {
    try {
      const response = await apiClient.get(`/orders/${orderId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get order detail by ID using query parameter
  getOrderDetail: async (orderId) => {
    try {
      const response = await apiClient.get(`/order-detail?order_id=${orderId}`, {
        headers: {
          'Authorization': `${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create new order
  createOrder: async (orderData) => {
    try {
      const response = await apiClient.post('/orders', orderData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update order
  updateOrder: async (orderId, orderData) => {
    try {
      const response = await apiClient.put(`/orders/${orderId}`, orderData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete order
  deleteOrder: async (orderId) => {
    try {
      await apiClient.delete(`/orders/${orderId}`);
    } catch (error) {
      throw error;
    }
  },

  // Check order status by mobile number
  checkOrderStatus: async (mobileNumber) => {
    try {
      const response = await apiClient.get(`/check-order-status?mobile_number=${mobileNumber}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default orderApi; 